import React from 'react';
import { toast } from 'sonner';
import AddInvestmentModal from '../AddInvestmentModal';
import SubscriptionModal from '../SubscriptionModal';
import SubscriptionSuccessModal from '../SubscriptionSuccessModal';
import WelcomeModal from '../WelcomeModal';
import PrivacyWelcomeSlides from '../privacy/PrivacyWelcomeSlides';
import OnboardingTour from '../OnboardingTour';
import FeedbackWidget from '../FeedbackWidget';
import SharePortfolioModal from '../SharePortfolioModal';
import InstitutionImportModal from '../institution-import/InstitutionImportModal';
import BatchAddInvestmentsModal from '../investments/BatchAddInvestmentsModal';
import AssistedOnboardingModal from '../AssistedOnboardingModal';
import QuickSetupCallModal from '../QuickSetupCallModal';
import DeepOnboardingModal from '../DeepOnboardingModal';
import QuickSetupTrigger from '../QuickSetupTrigger';
import { useModalRegistration } from '../../contexts/ModalGuardContext';

const DashboardModals = ({
  user,
  showAddModal, setShowAddModal, selectedInvestment, setSelectedInvestment,
  handleAddInvestmentSuccess,
  showSubscriptionModal, setShowSubscriptionModal,
  subscriptionModalDefaultType, setSubscriptionModalDefaultType,
  showSuccessModal, setShowSuccessModal,
  showWelcomeModal, setShowWelcomeModal,
  showPrivacyWelcome, setShowPrivacyWelcome,
  runTour, handleStartTour, handleCloseTour,
  showShareModal, setShowShareModal,
  showInstitutionImportModal, setShowInstitutionImportModal, loadDashboardData,
  setInstitutionImportSuccessMessage,
  showBatchAddModal, setShowBatchAddModal,
  showOnboardingModal, setShowOnboardingModal,
  showQuickSetupModal, setShowQuickSetupModal,
  showDeepOnboardingModal, setShowDeepOnboardingModal,
}) => {
  // Register every modal with the global ModalGuard so triggers anywhere in
  // the app know whether something is already open. The Tour and FeedbackWidget
  // self-register inside their own components.
  useModalRegistration('add-investment-modal', !!showAddModal);
  useModalRegistration('subscription-modal', !!showSubscriptionModal);
  useModalRegistration('subscription-success-modal', !!showSuccessModal);
  useModalRegistration('welcome-modal', !!showWelcomeModal);
  useModalRegistration('privacy-welcome-slides', !!showPrivacyWelcome);
  useModalRegistration('share-portfolio-modal', !!showShareModal);
  useModalRegistration('institution-import-modal', !!showInstitutionImportModal);
  useModalRegistration('assisted-onboarding-modal', !!showOnboardingModal);
  useModalRegistration('quick-setup-call-modal', !!showQuickSetupModal);
  useModalRegistration('deep-onboarding-modal', !!showDeepOnboardingModal);

  return (
    <>
      {showAddModal && (
        <AddInvestmentModal
          isOpen={showAddModal}
          onClose={() => { setShowAddModal(false); setSelectedInvestment(null); }}
          onSuccess={handleAddInvestmentSuccess}
          investment={selectedInvestment}
          user={user}
        />
      )}
      {showAddModal && (
        <QuickSetupTrigger onRequestCall={() => { setShowAddModal(false); setShowQuickSetupModal(true); }} />
      )}
      {showSubscriptionModal && (
        <SubscriptionModal
          isOpen={showSubscriptionModal}
          onClose={() => { setShowSubscriptionModal(false); setSubscriptionModalDefaultType('monthly'); }}
          user={user}
          defaultType={subscriptionModalDefaultType}
        />
      )}
      {showSuccessModal && (
        <SubscriptionSuccessModal isOpen={showSuccessModal} onClose={() => setShowSuccessModal(false)} />
      )}
      <WelcomeModal
        isOpen={showWelcomeModal}
        onClose={() => setShowWelcomeModal(false)}
        onStartTour={handleStartTour}
        userName={user?.code_name}
      />
      <PrivacyWelcomeSlides
        isOpen={showPrivacyWelcome}
        onClose={() => setShowPrivacyWelcome(false)}
        onGoToPrivacy={() => window.dispatchEvent(new CustomEvent('mif:go-to-tab', { detail: 'privacy' }))}
      />
      <OnboardingTour isActive={runTour} onComplete={handleCloseTour} />
      <FeedbackWidget />
      <SharePortfolioModal isOpen={showShareModal} onClose={() => setShowShareModal(false)} user={user} />
      <InstitutionImportModal
        isOpen={showInstitutionImportModal}
        onClose={() => setShowInstitutionImportModal(false)}
        onEnterManually={() => {
          setSelectedInvestment(null);
          setShowAddModal(true);
        }}
        onImportSuccess={(message) => {
          if (message) setInstitutionImportSuccessMessage?.(message);
          loadDashboardData();
        }}
      />
      {showBatchAddModal && (
        <BatchAddInvestmentsModal
          isOpen={showBatchAddModal}
          onClose={() => setShowBatchAddModal(false)}
          onSuccess={() => loadDashboardData()}
        />
      )}
      <AssistedOnboardingModal
        isOpen={showOnboardingModal}
        onClose={() => setShowOnboardingModal(false)}
        onSuccess={() => toast.success("Onboarding session requested! We'll confirm shortly.")}
      />
      <QuickSetupCallModal
        isOpen={showQuickSetupModal}
        onClose={() => setShowQuickSetupModal(false)}
        onSuccess={() => toast.success('Quick Virtual Setup Session booked!')}
      />
      <DeepOnboardingModal
        isOpen={showDeepOnboardingModal}
        onClose={() => setShowDeepOnboardingModal(false)}
        onSuccess={() => toast.success('Deep Onboarding request submitted!')}
      />
    </>
  );
};

export default DashboardModals;
